export const scrollToProjectSection = (projectKey) => {
    if (!projectKey || typeof document === 'undefined') return false;

    const target = document.getElementById(`${projectKey}-header`);
    if (!target || typeof target.scrollIntoView !== 'function') return false;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
    }
    return true;
};

export default scrollToProjectSection;
